import * as React from 'react';
import * as cn from 'classnames';
import { Button } from '@mq/aurora-components/dist/button';
import { ILink } from '../login-page/login-page-links';
import { IBaseProps } from '../../types';
import { LogoGoldman } from '../logos/logo-goldman';
import * as styles from './header-mobile.css';

interface IHeaderMobileState {
  isOpen: boolean;
}

interface IHeaderMobileProps extends IBaseProps {
  links: ILink[];
}

export class HeaderMobile extends React.Component<IHeaderMobileProps, IHeaderMobileState> {
  state: IHeaderMobileState = {
    isOpen: false
  };

  private toggleMenu = () =>
    this.setState({
      isOpen: !this.state.isOpen
    });

  /** *************************************************
   **  Renderers
   **************************************************/
  private renderMenuButton = (): JSX.Element => {
    const { isOpen } = this.state;

    const icon: string = isOpen ? 'clear' : 'menu';

    return (
      <Button
        className={cn(styles.menuBtn, {
          [styles.activeBtn]: isOpen
        })}
        ghost
        onClick={this.toggleMenu}
      >
        <i className="material-icons">{icon}</i>
      </Button>
    );
  };

  private renderLinks = (): JSX.Element => {
    const {
      match: { url },
      links
    } = this.props;

    return (
      <ul>
        {links.map(l => (
          <li
            key={l.url}
            className={cn({
              [styles.active]: url.includes(l.url)
            })}
          >
            <a href={l.url}>{l.title}</a>
          </li>
        ))}
      </ul>
    );
  };

  render() {
    const { isOpen } = this.state;

    return (
      <div>
        <div className={styles.headerMobile}>
          {this.renderMenuButton()}

          <div className={styles.logo}>
            <LogoGoldman className={styles.gsLogo} color="#ffffff" />
          </div>
        </div>

        <div
          className={cn(styles.headerMenu, {
            [styles.headerOpen]: isOpen
          })}
        >
          {this.renderLinks()}

          <div className={styles.gsLogo}>
            <a href="https://www.gs.com" target="_blank" rel="noreferrer">
              <LogoGoldman color="#999999" />
            </a>
          </div>
        </div>
      </div>
    );
  }
}
